module.exports = __webpack_public_path__ + "static/media/project-img2.7fc6e729.png";